// src/components/desktop/desktopAppMonetize/DesktopAppMonetize.jsx
import { useEffect, useState } from "react";
import SeoTags from "../../../seo/SeoTags";
import LeftRail from "../left-rail/LeftRail";
import { useLang } from "../../../i18n/LangContext";
import DesktopMonetizeHero from "./hero/DesktopMonetizeHero";
import "./DesktopAppRegisterPublisher.css";
import RegisterFormPublisher from "../../common/register/RegisterFormPublisher";
import DesktopFooter from "../footer/DesktopFooter";
import GlobeFx from "../../../assets/footer/globe.png";
import GlobeBase from "../../../assets/footer/globe 1.png";
import LogoPNG from "../../../assets/footer/logo-footer.png";

export default function DesktopAppRegisterPublisher({
  onSelectPublisher = () => {},
  onSelectAdvertiser = () => {},
  onLogin = () => {},
  onRegister = () => {},
}) {
  const { lang, t } = useLang();
  const isBG = lang === "bg";

  const [showOverlay, setShowOverlay] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFadeOut(true), 1000);
    const t2 = setTimeout(() => setShowOverlay(false), 1200);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);


  const base = "https://offerwall-web-9dd25471534d.herokuapp.com";
  const url = `${base}/monetize`;
  const canonical = url;
  const locale = isBG ? "bg_BG" : "en_US";

  const title = isBG
    ? "Givvy Offerwall — Монетизирай аудиторията си"
    : "Givvy Offerwall — Monetize With Premium Offerwall Traffic";

  const description = isBG
    ? "Свържи се с глобална мрежа от рекламодатели, които ценят надеждните издатели."
    : "Connect with a global network of advertisers looking for trusted publishers and direct offerwall traffic.";


  const scrollToRegister = () => {
    if (typeof window === "undefined") return;
    const target = document.getElementById("register");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const sections = [
    { id: "join-us", label: t.nav.monetize },
    { id: "register", label: t.registerForm.eyebrow },
  ];

  return (
    <>
      <SeoTags
        title={title}
        description={description}
        url={url}
        canonical={canonical}
        locale={locale}
        alternates={[{ href: url, hreflang: "x-default" }]}
        image={`${base}/og/og-hero.jpg`}
      />

      <LeftRail
        sections={sections}
        railLeft={100}
        navHeight={88}
        dotSize={16}
        dotsSide="left"
        dotsGap={54}
        dotsVAlign="center"
      />

      <div className="desktop-monetize-area">
        <DesktopMonetizeHero
          id="join-us"
          onPublisher={scrollToRegister}
          onAdvertiser={scrollToRegister}
        />
        <RegisterFormPublisher
          id="register"
          eyebrow={t.registerForm.eyebrow}
          title={t.registerForm.titleLine1}
          loginLabel={t.registerForm.loginCta}
          submitLabel={t.registerForm.submit}
          fields={t.registerForm.fields}
          onLogin={onLogin}
          onSubmit={onRegister}
        />
        <DesktopFooter
          logoSrc={LogoPNG}
          globeSrc={GlobeBase}
          globeOverlaySrc={GlobeFx}   // <-- тук подаваме overlay-a
          socialLinks={[
            "https://facebook.com/…",
            "https://instagram.com/…",
            "https://youtube.com/…",
            "https://t.me/…",
            "https://x.com/…",
            "https://tiktok.com/@…",
          ]}
        />
      </div>
    </>
  );
}
